<script>
    //import * as mod from '../components/cookieconcent.js';
    import 'vanilla-cookieconsent'
    import {onMount} from 'svelte';
    import {searchFromArray, ccOptions, getCookie} from '../components/utils.js'
    import Blog from '../components/Blog.svelte'
    import Ajankohtaista from '../components/Ajankohtaista.svelte'
    import WodConnect from '../components/WodConnect.svelte'
    import FaceBookFeed from '../components/FacebookFeed.svelte'
    import MailChimp from '../components/MailChimp.svelte'
    import Slider from "../components/Slider.svelte";


    /*Käytä sliderissa kuvia, joiden koko on vähintään w800mh400, niin skaalaus toimii eri näyttöleveyksillä.*/
    let slides = [
        {
            src: './svelte-site/img/ajankohtaista/kansi-2.jpg',
            header: "Toiminnallinen kuntosali keskellä Kempelettä",
            content: "Ilmainen tutustuminen, aina edulliset treenit",
        },
    ];

    // Lisätään pakolliset id:t slidesseihin
    for(var i = 0; i < slides.length; i++) {
        slides[i].id = (i + 1);
    }

    // Haetaan onMountissa evästeistä tieto, että näytetäänkö WodConnect ja FaceFeed
    // Tallennetaan tieto loadOtherCookies muuttujaan
    let loadOtherCookies = false;
    let myCookie;
    onMount(() => {

        myCookie = getCookie('cc_cookie');
        if(myCookie !== null && myCookie !== "") {
            let jscookie = JSON.parse(myCookie);
            let cookieCategories = searchFromArray("other",jscookie.categories);
            if(cookieCategories !== null && cookieCategories.length > 0) {
                loadOtherCookies = true;
            } else {
                console.log("loadOtherCookies ei haluttu!!", (cookieCategories !== null));
            }
        }
    });
</script>
<div>
    <div>
        <Slider sliderSlides="{slides}" sliderSpeedMs="7000"/>
    </div>

    <div class="page">
        <div class="container">

            <section>
                <a class="bigButton" href="/aloittaminen">Näin aloitat harjoittelun</a>
                <a class="bigButton" href="https://holvi.com/shop/dynamosali/">Hanki jäsenyys verkkokaupasta</a>
            </section>


            <section class="newsContainer">
                <h2><a href="/ajankohtaista" class="hover-decoration">Ajankohtaista</a></h2>
                <Ajankohtaista summary="true"/>
                <p><a href="./ajankohtaista">Kaikki ajankohtaiset</a></p>
            </section>

            <hr>
      
            <section class="blogContainer">
                <h2><a href="/blog" class="hover-decoration">Blogissa</a></h2>
                <Blog summary="true"/>
                <p><a href="./blog">Kaikki blogitekstit</a></p>
            </section>

            <hr>

            <!-- WodConnect, Facebook ja Uutiskirje -->
            <section class="row">
                <div class="componentContainer col-xs-12 col-md-4">
                    {#if loadOtherCookies}
                        <WodConnect/>
                    {:else}
                        <div>
                            <p>Olet estänyt muiden evästeiden käytön, joten emme voi näyttää
                            WodConnectin komponenttia tässä.</p>
                            <small>Dynamosalin päivän treenit löydät WodConnectista.</small>
                            <button class="btn btn-primary" type="button" aria-label="View cookie settings"
                                    data-cc="accept-all">Hyväksy kaikki evästeet
                            </button>
                        </div>
                    {/if}
                </div>
                <div class="componentContainer col-xs-12 col-md-4">
                    {#if loadOtherCookies}
                        <FaceBookFeed/>
                    {:else}
                        <div>
                            <p>Olet estänyt muiden evästeiden käytön, joten emme voi näyttää
                            Facebookin komponenttia tässä.</p>
                            <button class="btn btn-primary" type="button" aria-label="View cookie settings"
                                    data-cc="accept-all">Hyväksy kaikki evästeet
                            </button>
                        </div>
                    {/if}
                </div>
                <div class="componentContainer col-xs-12 col-md-4">
                    <MailChimp/>
                </div>
            </section>
        </div>
    </div>
</div>


